// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__q0dbl","heading":"LandingPage_heading__wWHfs","cardsContainer":"LandingPage_cardsContainer__kMHfP"};